/* eslint-disable import/prefer-default-export, react/jsx-curly-brace-presence, react/jsx-key */

import getKey from 'lodash/get';
import isArray from 'lodash/isArray';
import moment from 'moment-timezone';
import styled, { css } from 'styled-components';
import Alert from 'antd/lib/alert';
import Message from 'antd/lib/message';
import React, { useMemo, useState, useCallback, useRef } from 'react';

// eslint-disable-next-line import/no-extraneous-dependencies
import { Link } from 'react-router-dom';

import {
  LinkOutlined,
  QuestionCircleOutlined,
  DownloadOutlined,
  UploadOutlined,
  DeleteOutlined,
  FilePdfOutlined,
} from '@ant-design/icons';

import { Tooltip } from 'hive-admin/src/components/Popover';

import Tag from 'antd/lib/tag';
import List from 'antd/lib/list';
import Button from 'antd/lib/button';
import Spin from 'antd/lib/spin';
import Avatar from 'antd/lib/avatar';
import Descriptions from 'antd/lib/descriptions';
import AntdTable from 'antd/lib/table';
import AntdRate from 'antd/lib/rate';

import getRoleBasedPath from '../../../helpers/getRoleBasedPath';

import copyToClipboard, {
  getServerUrl,
} from '../../../helpers/copyToClipboard';
import {
  DateLink,
  EmailLink,
  PhoneNumberLink,
  OrderStatusLink,
  StoreLink,
} from '../../../components/Links';

import Admin from '../../../components/Admin';
import { createChangeLogSection } from '../../../components/FieldChangeLog';
import { renderCurrency } from '../../../components/SystemCountry';

import Types from '../../../modules/types';

import tests from '../../../helpers/tests';

import applePayMarkSrc from '../../../assets/apple-pay-mark.svg';

const {
  CONSTANTS: {
    PaymentProvider,
    ShippingProvider,
    ShippingStorage,
    OrderStatus,
  },
} = Types;

const {
  viewerIsAdminAndDoesNotHavePermission,
  getLatestPaymentStatus,
} = tests;

const Rate = styled(AntdRate)`
  color: ${({ theme }) => theme.less.primaryColor};

  ${({ disabled }) => disabled && css`
    .ant-rate-star > div:hover, .ant-rate-star > div:focus {
      transform: none;
    }
  `}
`;

export const GhostTag = styled(Tag)`
  border-color: ${({ theme }) => theme.less.primaryColor} !important;
  background-color: transparent !important;
  color: ${({ theme }) => theme.less.primaryColor} !important;
  margin-right: 0px !important;
  align-self: center;
`;

export const ValueSpaceBetweenWrapper = styled.span`
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  gap: 3px;
`;

export const DisabledDownloadOutlined = styled(DownloadOutlined)`
  color: ${({ theme }) => theme.less.colorDisabled};
  pointer-events: none;
`;

export const ValueSpaceBetweenRight = styled.span`
  padding-left: 5px;
`;

export const ValueSpaceBetweenLeft = styled.span`
  /* margin-right: -9px; */
  /* margin-top: -2px; */
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 5px;
`;

export const DescriptionLabel = styled.span`
  display: inline-block;
  width: 100%;
  /* &:after {
    content: ":";
  } */
`;

export const DescriptionValue = styled.span`
  width: 100%;
  display: inline-block;
  overflow-wrap: break-word;
  a, span {
    word-break: break-word;
  }
`;

export const OrderDescription = styled(Descriptions)`
  .ant-descriptions-title {
    font-size: 22px;
  }
  .ant-descriptions-row {
    vertical-align: top;
  }
  .ant-descriptions-item-label,
  .ant-descriptions-item-content {
    vertical-align: top;
    padding: 6px 12px 7px !important;
    width: 100%;
  }
  .ant-descriptions-item-label {
    color: ${({ theme }) => theme.less.textColor} !important;
    opacity: 0.7;
    min-width: 120px;
    width: 30%;
    flex-shrink: 0;
    white-space: nowrap;
    &.ant-descriptions-item-no-label {
      display: none;
      & + .ant-descriptions-item-content {
        padding: 0px !important;
      }
    }
  }
  .ant-descriptions-item {
    display: flex;
  }
  .ant-list-item {
    border-bottom: 0px;
  }
`;

export const OrderPopover = styled(Tooltip)`
  max-width: 400px;
`;

export const OrderPartyDetailsTitle = styled.span`
`;

export const OrderPopoverIcon = styled(QuestionCircleOutlined)`
  opacity: 0.4;
  transform: scale(0.7) translateY(2px);
  cursor: pointer;
`;

export const OrderDescriptionSectionSeparator = styled.div`
  height: 20px;
`;

export const ApplePayMark = styled.img`
  width: 30px;
  margin-left: 8px;
  transform: translateY(-2px);
  opacity: 0.6;
`;

export const OrderItemPopoverImage = styled.img`
  max-width: min(300px, 70vw);
  width: 100%;
  height: auto;
`;

export const DescriptionTable = styled(AntdTable)`
  width: 100%;
  tr {
    vertical-align: top;
  }
  td {
    padding: 6px 12px 7px !important;
    &:first-child {
      background-color: #fafafa;
    }
  }
`;

// const OrderDescription = styled(Descriptions)`
//   .ant-descriptions-title {
//     font-size: 22px;
//   }
//   .ant-descriptions-item {
//     display: flex;
//   }
//   .ant-list-item {
//     border-bottom: 0px;
//   }
// `;

// const OrderDescriptionSectionSeparator = styled.div`
//   height: 20px;
// `;

// function ifViewerIs(props, role, ifIs, ifIsNot) {
//   return (
//       !role && !props.viewer
//     ? ifIs
//     : !props.viewer
//     ? ifIsNot
//     : props.viewer.role === role
//     ? ifIs
//     : ifIsNot
//   );
// }

function createLinkForPastRequestSubject(props, status) {
  if (props && props.viewer && props.data) {
    if (
      props.viewer
      && props.viewer.role === 'ADMIN'
    ) {
      const subject = (
        status === 'APPROVED'
        ? props.data.approvedRequestSentBy
        : status === 'SHIPPED'
        ? props.data.shippedRequestSentBy
        : status === 'COMPLETED'
        ? props.data.completedRequestSentBy
        : undefined
      );
      if (!!subject && subject._id && subject.name) {
        return (
          <>
            {', by '}
            <Link to={`/users/${subject._id}`}>{subject.name}</Link>
          </>
        );
      }
    }
  }
  return '';
}

const ColumnWithAction = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  @media (max-width: 986px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 2px; 
  }

  @media (max-width: 768px) {
    button {
      height: 24px !important;
      padding: 0 7px !important;
      font-size: 16px !important;
      border-radius: ${({ theme }) => theme.less.borderRadius} !important;
    }
  }

`;
// eslint-disable-next-line max-len
const ActionUpdateStatus = (propsFromPage) => {
  const action = useMemo(
    () => (
      Admin.compileFromLibrary(['ActionWithFormModal', {
        name: 'update-status',
        title: 'Update order status',
        // type: 'danger',
        size: 'small',
        ghost: true,
        fields: [
          ['FieldReact', {
            name: 'Info',
            renderContent: () => (
              <div>
                <p>
                  <strong>Warning:</strong>
                  {' '}
                  This action will not send any emails
                  or update the stock of the store, but further changes might.
                  Use with caution.
                </p>
              </div>
            ),
          }],
          ['FieldSelect', {
            name: 'statusNew',
            label: null,
            prefix: 'Status:',
            // eslint-disable-next-line max-len
            placeholder: 'Select order status',
            choices: [
              OrderStatus.APPROVAL,
              OrderStatus.NEW,
              OrderStatus.DELIVERY,
              OrderStatus.DELIVERED,
              OrderStatus.FAILED,
              OrderStatus.INVALID_PAYMENT,
            ].map(status => ({
              value: status,
              label: Types.ORDER_STATUS_LABELS_MAP[status],
            })),
          }],
        ],
        actions: [
          ['ActionWithRequest', {
            name: 'update-status',
            title: 'Force Update',
            skip: [],
            handleSuccess: (data, props) => props.reload(),
            getRequestConfig: props => ({
              url: `orders/${props.data._id}/update-status-admin`,
              method: 'POST',
              data: props.form.getFieldsValue(),
            }),
          }],
        ],
      }])
    ),
    [],
  );
  return action.render({
    data: propsFromPage.data,
    reload: propsFromPage.reload,
    // record: propsFromPage.data,
    client: propsFromPage.client,
  });
};
const ActionUpdatePaymentStatus = (propsFromPage) => {
  const action = useMemo(
    () => (
      Admin.compileFromLibrary(['ActionWithFormModal', {
        name: 'update-status',
        title: 'Update payment status',
        // type: 'danger',
        size: 'small',
        ghost: true,
        fields: [
          ['FieldReact', {
            name: 'Info',
            renderContent: () => (
              <div>
                <p>
                  <strong>Warning:</strong>
                  {' '}
                  This action will not send any emails
                  or update the stock of the store, but further changes might.
                  Use with caution.
                </p>
              </div>
            ),
          }],
          ['FieldSelect', {
            name: 'paymentStatus',
            label: null,
            prefix: 'Status:',
            // eslint-disable-next-line max-len
            placeholder: 'Select payment status',
            choices: [
                'Authorized',
                'Voided',
                'Captured',
                'Refunded',
            ].map(status => ({
              // eslint-disable-next-line max-len
              value: Types.New_PAYMENT_STATUSES_ARR.find(item => item === status.toUpperCase()),
               // eslint-disable-next-line max-len
              label: tests.toCapitalized(Types.New_PAYMENT_STATUSES_ARR.find(item => item === status.toUpperCase())),
            })),
          }],
        ],
        actions: [
          ['ActionWithRequest', {
            name: 'update-status',
            title: 'Force Update',
            skip: [],
            handleSuccess: (data, props) => props.reload(),
            getRequestConfig: props => ({
              url: `orders/${props.data._id}/update-payment-status-admin`,
              method: 'POST',
              data: props.form.getFieldsValue(),
            }),
          }],
        ],
      }])
    ),
    [],
  );
  return action.render({
    data: propsFromPage.data,
    reload: propsFromPage.reload,
    // record: propsFromPage.data,
    client: propsFromPage.client,
  });
};

const ActionUpdateCompletedAt = (propsFromPage) => {
  const action = useMemo(
    () => (
      Admin.compileFromLibrary(['ActionWithFormModal', {
        name: 'action-update-completed-at',
        title: 'Force Update',
        size: 'small',
        fields: [
          ['FieldReact', {
            name: 'Info',
            renderContent: () => (
              <div>
                <p>
                  <strong>Warning:</strong>
                  {' '}
                  This action will not send any emails or
                  update any previous actions. Use with caution.
                </p>
              </div>
            ),
          }],
          Admin.compileFromLibrary(['FieldDatePicker', {
            name: 'completedAt',
            label: 'Completed At',
            prepareValueForInput: (
              value => (value ? moment(value) : moment()
              )),
            format: ['DD.MM.YYYY. HH:mm'],
            required: true,
            showTime: {
              // disabledMinutes: () => new Array(59).fill(0).map((n, i) => ++i),
              disabledSeconds: () => new Array(60).fill(0).map((n, i) => i + 1),
              // minuteStep: 15,
              hideDisabledOptions: true,
            },
          }]),
        ],
        actions: [
          ['ActionWithRequest', {
            name: 'update-completed-at',
            title: 'Force Update',
            skip: [],
            handleSuccess: (data, props) => props.reload(),
            getRequestConfig: props => ({
              url: `orders/${props.data._id}/update-completed-at-admin`,
              method: 'POST',
              data: props.form.getFieldsValue(),
            }),
          }],
        ],
        ghost: true,
      }])
    ),
    [],
  );

  return action.render({
    data: propsFromPage.data,
    reload: propsFromPage.reload,
    // record: propsFromPage.data,
    client: propsFromPage.client,
  });
};

const AwbContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

const AwbAttachmentBox = styled.a`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  background: #fafafa;
  color: inherit;
  text-decoration: none;
  width: 100%;

  &:hover {
    background: #fff;
    border-color: ${({ theme }) => theme.less.primaryColor};
  }
`;

const AwbAttachmentMeta = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
`;

const AwbAttachmentName = styled.div`
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const AwbAttachmentSize = styled.div`
  font-size: 12px;
  color: #999;
`;

const AwbControls = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
`;

const AwbHiddenInput = styled.input`
  display: none;
`;

const AWB_ALLOWED_EXTENSIONS = ['pdf', 'jpg', 'jpeg', 'png'];
const AWB_ALLOWED_MIMES = ['application/pdf', 'image/jpeg', 'image/png'];
const AWB_MAX_SIZE = 10 * 1024 * 1024; // 10MB

function formatBytes(bytes) {
  if (typeof bytes !== 'number' || Number.isNaN(bytes)) return null;
  if (bytes < 1024) return `${bytes} B`;
  const kb = bytes / 1024;
  if (kb < 1024) return `${kb.toFixed(1)} KB`;
  const mb = kb / 1024;
  return `${mb.toFixed(1)} MB`;
}

function AirwayBillSection({ data, client, reload, viewer }) {
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);

  const canManage = (
    viewer?.role === 'ADMIN'
    && viewer?.permissions?.ordersAwbManage?.includes(viewer._id)
  );

  const airwayBill = data?.airwayBill;

  const handleDownload = useCallback(async () => {
    if (!airwayBill?._id) return;
    setLoading(true);
    try {
      const filename = airwayBill?.meta?.filename || 'airway-bill.pdf';
      const res = await client.request({
        url: `files/${airwayBill._id}/download`,
        method: 'GET',
        responseType: 'blob',
      });

      const blob = new Blob(
        [res.data],
        { type: airwayBill?.meta?.mime || 'application/octet-stream' },
      );

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      const msg = (
        err?.response?.data?.message
        || err?.message
        || 'Download failed'
      );
      Message.error(msg);
    } finally {
      setLoading(false);
    }
  }, [airwayBill, client]);

  const handleUpload = useCallback(async (e) => {
    const file = e.target.files?.[0];
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    if (!file) return;

    const ext = file.name.split('.').pop().toLowerCase();
    if (!AWB_ALLOWED_EXTENSIONS.includes(ext)) {
      Message.error('Invalid file type. Allowed: PDF, JPG, PNG.');
      return;
    }
    if (!AWB_ALLOWED_MIMES.includes(file.type)) {
      Message.error('Invalid file type. Allowed: PDF, JPG, PNG.');
      return;
    }
    if (file.size > AWB_MAX_SIZE) {
      Message.error('File too large. Maximum size is 10MB.');
      return;
    }

    setLoading(true);
    try {
      const form = new FormData();
      form.append('file', file);
      await client.request({
        url: `orders/${data._id}/airway-bill`,
        method: 'POST',
        data: form,
      });
      Message.success(
        airwayBill ? 'AWB replaced successfully' : 'AWB uploaded successfully',
      );
      reload();
    } catch (err) {
      const msg = err?.response?.data?.message || err?.message || 'Upload failed';
      Message.error(msg);
    } finally {
      setLoading(false);
    }
  }, [client, data?._id, reload, airwayBill]);

  const handleDelete = useCallback(async () => {
    setLoading(true);
    try {
      await client.request({
        url: `orders/${data._id}/airway-bill`,
        method: 'DELETE',
      });
      Message.success('AWB deleted successfully');
      reload();
    } catch (err) {
      const msg = err?.response?.data?.message || err?.message || 'Delete failed';
      Message.error(msg);
    } finally {
      setLoading(false);
    }
  }, [client, data?._id, reload]);

  return (
    <AwbContainer>
      <Spin spinning={loading}>
        {airwayBill?.src ? (
          <AwbAttachmentBox
            href={airwayBill.src}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FilePdfOutlined style={{ fontSize: 22, color: '#d32029' }} />
            <AwbAttachmentMeta>
              <AwbAttachmentName>
                {airwayBill?.meta?.filename || 'Airway Bill'}
              </AwbAttachmentName>
              {airwayBill?.meta?.size ? (
                <AwbAttachmentSize>
                  {formatBytes(airwayBill.meta.size)}
                </AwbAttachmentSize>
              ) : null}
            </AwbAttachmentMeta>
          </AwbAttachmentBox>
        ) : (
          <div style={{ color: '#999' }}>No airway bill attached</div>
        )}
        <AwbControls>
          {airwayBill?._id && (
            <Button
              size="small"
              icon={<DownloadOutlined />}
              onClick={handleDownload}
            >
              Download
            </Button>
          )}
          {canManage && (
            <>
              <AwbHiddenInput
                hidden
                ref={fileInputRef}
                type="file"
                accept=".pdf,.jpg,.jpeg,.png"
                onChange={handleUpload}
              />
              <Button
                size="small"
                icon={<UploadOutlined />}
                onClick={() => fileInputRef.current?.click()}
              >
                {airwayBill ? 'Replace' : 'Upload'}
              </Button>
              {airwayBill && (
                <Button
                  size="small"
                  danger
                  icon={<DeleteOutlined />}
                  onClick={handleDelete}
                >
                  Delete
                </Button>
              )}
            </>
          )}
        </AwbControls>
      </Spin>
    </AwbContainer>
  );
}

function InvoiceSection({ data, client, reload, viewer }) {
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);

  const canManage = (
    viewer?.role === 'ADMIN'
    && viewer?.permissions?.ordersInvoiceManage?.includes(viewer._id)
  );

  const invoice = data?.invoice;

  const handleDownload = useCallback(async () => {
    if (!invoice?._id) return;
    setLoading(true);
    try {
      const filename = invoice?.meta?.filename || 'invoice.pdf';
      const res = await client.request({
        url: `files/${invoice._id}/download`,
        method: 'GET',
        responseType: 'blob',
      });

      const blob = new Blob(
        [res.data],
        { type: invoice?.meta?.mime || 'application/octet-stream' },
      );

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      const msg = (
        err?.response?.data?.message
        || err?.message
        || 'Download failed'
      );
      Message.error(msg);
    } finally {
      setLoading(false);
    }
  }, [invoice, client]);

  const handleUpload = useCallback(async (e) => {
    const file = e.target.files?.[0];
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    if (!file) return;

    const ext = file.name.split('.').pop().toLowerCase();
    if (!AWB_ALLOWED_EXTENSIONS.includes(ext)) {
      Message.error('Invalid file type. Allowed: PDF, JPG, PNG.');
      return;
    }
    if (!AWB_ALLOWED_MIMES.includes(file.type)) {
      Message.error('Invalid file type. Allowed: PDF, JPG, PNG.');
      return;
    }
    if (file.size > AWB_MAX_SIZE) {
      Message.error('File too large. Maximum size is 10MB.');
      return;
    }

    setLoading(true);
    try {
      const form = new FormData();
      form.append('file', file);
      await client.request({
        url: `orders/${data._id}/invoice`,
        method: 'POST',
        data: form,
      });
      Message.success(
        invoice ? 'Invoice replaced successfully' : 'Invoice uploaded successfully',
      );
      reload();
    } catch (err) {
      const msg = err?.response?.data?.message || err?.message || 'Upload failed';
      Message.error(msg);
    } finally {
      setLoading(false);
    }
  }, [client, data?._id, reload, invoice]);

  const handleDelete = useCallback(async () => {
    setLoading(true);
    try {
      await client.request({
        url: `orders/${data._id}/invoice`,
        method: 'DELETE',
      });
      Message.success('Invoice deleted successfully');
      reload();
    } catch (err) {
      const msg = err?.response?.data?.message || err?.message || 'Delete failed';
      Message.error(msg);
    } finally {
      setLoading(false);
    }
  }, [client, data?._id, reload]);

  return (
    <AwbContainer>
      <Spin spinning={loading}>
        {invoice?.src ? (
          <AwbAttachmentBox
            href={invoice.src}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FilePdfOutlined style={{ fontSize: 22, color: '#d32029' }} />
            <AwbAttachmentMeta>
              <AwbAttachmentName>
                {invoice?.meta?.filename || 'Invoice'}
              </AwbAttachmentName>
              {invoice?.meta?.size ? (
                <AwbAttachmentSize>
                  {formatBytes(invoice.meta.size)}
                </AwbAttachmentSize>
              ) : null}
            </AwbAttachmentMeta>
          </AwbAttachmentBox>
        ) : (
          <div style={{ color: '#999' }}>No invoice attached</div>
        )}
        <AwbControls>
          {invoice?._id && (
            <Button
              size="small"
              icon={<DownloadOutlined />}
              onClick={handleDownload}
            >
              Download
            </Button>
          )}
          {canManage && (
            <>
              <AwbHiddenInput
                hidden
                ref={fileInputRef}
                type="file"
                accept=".pdf,.jpg,.jpeg,.png"
                onChange={handleUpload}
              />
              <Button
                size="small"
                icon={<UploadOutlined />}
                onClick={() => fileInputRef.current?.click()}
              >
                {invoice ? 'Replace' : 'Upload'}
              </Button>
              {invoice && (
                <Button
                  size="small"
                  danger
                  icon={<DeleteOutlined />}
                  onClick={handleDelete}
                >
                  Delete
                </Button>
              )}
            </>
          )}
        </AwbControls>
      </Spin>
    </AwbContainer>
  );
}

const FIELDS = [
  ['FieldReact', {
    name: '_all',
    label: null,
    renderContent: (props) => {
      if (!props.data || !props.viewer) {
        return null;
      }
      const { viewer, data } = props;
      let cost = data.cost || {};
      let items = data.items || [];
      let isSellerOnResellerOrder = false;
      const isAdmin = viewer && viewer.role === 'ADMIN';
      const isStorageWarehouse = (
        data?.shipping?.storage === ShippingStorage.WAREHOUSE
      );
      if (
        data
        && data.store
        && data.store.type === 'RESELLER'
        && viewer
        && viewer.role === 'SELLER'
        && viewer.store !== data.store._id
      ) {
        isSellerOnResellerOrder = true;
        cost = data.costs.find(({ store }) => store === viewer.store);
        items = props.data.items.filter(
          ({ originStore }) => originStore === viewer.store,
        );
      }
      const {
        timezone,
        getCheckoutComTransactionUrlBasedOnStoreId,
      } = Types.getSystemCountry(data.systemCountry);
      // console.log(props.data);
      return [
        ['Details', [
          (
            viewer && viewer.role === 'ADMIN'
            ? (
                ['Store', (
                  // eslint-disable-next-line react/jsx-key
                  <StoreLink
                    location={props.location}
                    subject={data.store}
                    pathname={getRoleBasedPath(props, '/orders')}
                  />
                )]
              )
            : null
          ),
          (
              props.data.reorderedBy
            ? ['Reordered by', (
                // eslint-disable-next-line react/jsx-key
                <Link
                  to={
                    props.viewer && props.viewer.role === 'ADMIN'
                    ? `/orders/${props.data.reorderedBy}`
                    : `/store/orders/${props.data.reorderedBy}`
                  }
                >
                  {props.data.reorderedBy}
                </Link>
              )]
            : null
          ),
          (
              !isSellerOnResellerOrder && props.data.reorderOf
            ? ['Reorder of', (
                // eslint-disable-next-line react/jsx-key
                <Link
                  to={getRoleBasedPath(props, `/orders/${data.reorderOf}`)}
                >
                  {data.reorderOf}
                </Link>
              )]
            : null
          ),
          ['Status', (
            <ColumnWithAction>
              <div>
                <OrderStatusLink
                  location={props.location}
                  subject={props.data}
                  viewer={props.viewer}
                  pathname={getRoleBasedPath(props, '/orders')}
                />
                {(
                  (
                    props.data.status === 'INVALID_PAYMENT'
                    && props.data.payment?.paytabsMessage
                  )
                  ? ` (${props.data.payment?.paytabsMessage})`
                  : null
                )}
                {(
                  props?.data?.status === 'INVALID_PAYMENT'
                  && props?.data?.payment?.method === 'CARD'
                  && props?.data?.payment?.provider === 'CHECKOUT'
                  && !props?.data?.payment?.checkoutId
                  ? (
                    <span style={{ opacity: 0.6 }}>
                      &nbsp;
                      (Timed Out)
                    </span>
                  )
                  : null
                )}
              </div>
              {
                isAdmin
                && [
                  OrderStatus.INVALID,
                  OrderStatus.INVALID_PAYMENT,
                  OrderStatus.INVALID_APPROVAL,
                  OrderStatus.FAILED,
                  OrderStatus.DELIVERED,
                  OrderStatus.NEW,
                  OrderStatus.INVALID_SHIPPING,
                  OrderStatus.DELIVERY,
                ].includes(props?.data?.status)
                && !viewerIsAdminAndDoesNotHavePermission(
                  'ordersForceUpdateStatus'
                )(props)
                ? <ActionUpdateStatus {...props} />
                : null
              }
            </ColumnWithAction>
          )],
          ['Payment Status', (
            <ColumnWithAction>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <span style={{ textAlign: 'center' }}>
                  {(() => {
                    if (data?.payment?.method === 'COD_CASH') {
                      return (
                        <Alert
                          message="Cash On Delivery"
                          type="info"
                          // eslint-disable-next-line max-len
                          style={{ display: 'inline-block', padding: '4px 8px', fontSize: '13px' }}
                        />
                      );
                    }
                    if (data?.payment?.refunded) {
                      return (
                        <Alert
                          message="Refunded"
                          type="error"
                          // eslint-disable-next-line max-len
                          style={{ display: 'inline-block', padding: '4px 8px', fontSize: '13px' }}
                        />
                      );
                    }
                    if (data?.payment?.captured) {
                      return (
                        <Alert
                          message="Captured"
                          type="success"
                          // eslint-disable-next-line max-len
                          style={{ display: 'inline-block', padding: '4px 8px', fontSize: '13px' }}
                        />
                      );
                    }
                    if (data?.payment?.authorized) {
                      return (
                        <Alert
                          message="Authorized"
                          type="info"
                          // eslint-disable-next-line max-len
                          style={{ display: 'inline-block', padding: '4px 8px', fontSize: '13px' }}
                        />
                      );
                    }
                    if (data?.payment?.voided) {
                      return (
                        <Alert
                          message="Voided"
                          type="warning"
                          // eslint-disable-next-line max-len
                          style={{ display: 'inline-block', padding: '4px 8px', fontSize: '13px' }}
                        />
                      );
                    }
                    return '';
                  })()}
                </span>
              </div>
              {
              data?.payment?.method !== 'COD_CASH'
              && isAdmin
                && [
                  'authorized',
                  'captured',
                  'refunded',
                  'voided',
                  'unknown',
                ].includes(getLatestPaymentStatus(data.payment))
                && !viewerIsAdminAndDoesNotHavePermission(
                  'ordersForceUpdatePaymentStatus'
                )(props)
                ? <ActionUpdatePaymentStatus {...props} />
                : null
              }
            </ColumnWithAction>
          )],
          (
            data.status === 'DRAFT' && data.draftPurpose
            ? ['Draft Purpose:', (
                Types.DRAFT_PURPOSE_LABELS_MAP[data.draftPurpose]
              )]
            : null
          ),
          (
            (
              !isSellerOnResellerOrder
              && data.draftedFromPurpose === 'POS'
            )
            ? ['POS Checkout:', (
                data.draftedFrom
                ? (
                    <Link
                      to={getRoleBasedPath(
                        props,
                        `/orders/${data.draftedFrom}`,
                      )}
                    >
                      {data.draftedFrom}
                    </Link>
                  )
                : 'Yes'
              )]
            : null
          ),
          (
            data.referral
            ? ['Referral', (
                props.data.referralStoreName
              )]
            : null
          ),
          (
            data.store.type === 'RESELLER'
            ? ['Reseller', data.store.name]
            : null
          ),
          ['Created At', (
            // eslint-disable-next-line react/jsx-key
            <DateLink
              date={props.data.createdAt}
              location={props.location}
              pathname={getRoleBasedPath(props, '/orders')}
            >
              {moment(props.data.createdAt).format(
                'dddd, MMMM Do YYYY [at] h:mm a'
              )}
            </DateLink>
          )],
          (
            props.data.shipping?.scheduledFor
            ? ['Scheduled For', (() => {
                const momentDate = moment(props.data.shipping.scheduledFor)
                .tz(timezone);
                return momentDate
                .format(
                  `dddd, MMMM Do YYYY${
                    // momentDate.hour() > 0
                    // ? ' [at] hh:mm a'
                    // : ''
                    ''
                  } [(Local Time)]`,
                );
              })()]
            : null
          ),
          (
            props.data.approvedAt
            ? ['Approved At', (
                <>
                  <DateLink
                    date={props.data.approvedAt}
                    location={props.location}
                    pathname={getRoleBasedPath(props, '/orders')}
                  >
                    {moment(props.data.approvedAt).format(
                      'dddd, MMMM Do YYYY [at] h:mm a',
                    )}
                  </DateLink>
                  {createLinkForPastRequestSubject(props, 'APPROVED')}
                </>
              )]
            : null
          ),
          (
            props.data.shippedAt
            ? ['Shipped At', (
                // eslint-disable-next-line react/jsx-key
                <>
                  <DateLink
                    date={props.data.shippedAt}
                    location={props.location}
                    pathname={getRoleBasedPath(props, '/orders')}
                  >
                    {moment(props.data.shippedAt).format(
                      'dddd, MMMM Do YYYY [at] h:mm a',
                    )}
                  </DateLink>
                  {createLinkForPastRequestSubject(props, 'SHIPPED')}
                </>
              )]
            : null
          ),
          (
            props.data.completedAt
            ? ['Completed At', (
              // eslint-disable-next-line react/jsx-key
                <ColumnWithAction>
                  <div>
                    <DateLink
                      date={props.data.completedAt}
                      location={props.location}
                      pathname={getRoleBasedPath(props, '/orders')}
                    >
                      {moment(props.data.completedAt).format(
                        'dddd, MMMM Do YYYY [at] h:mm a',
                      )}
                    </DateLink>
                    {createLinkForPastRequestSubject(props, 'COMPLETED')}
                  </div>
                  {
                    isAdmin
                    && !viewerIsAdminAndDoesNotHavePermission(
                      'ordersForceUpdateStatus'
                    )(props)
                    ? <ActionUpdateCompletedAt {...props} />
                    : null
                  }
                </ColumnWithAction>
              )]
            : null
          ),
          ['Link', (
            // eslint-disable-next-line react/jsx-key
            <span>
              <a
                href={`${getServerUrl()}/order/${props.data._id}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {`${getServerUrl()}/order/${props.data._id}`}
              </a>
              <span>&nbsp;(</span>
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <a
                  href="#"
                  onClick={() => copyToClipboard(`${
                    getServerUrl()
                  }/order/${
                    props.data._id
                  }`)}
                >
                  <span>Copy&nbsp;</span>
                  <LinkOutlined />
                </a>
              <span>)</span>
            </span>
          )],
          ...(
            props.data.shipping && props.data.shipping.method
            ? [
                (
                  Types.SHIPPING_STORAGE_TANGIBLE.includes(
                    props.data.shipping.storage
                  )
                  ? ['Storage', (
                      Types.SHIPPING_STORAGE_LABELS_MAP[
                        props.data.shipping.storage
                      ]
                    )]
                  : null
                ),
                (
                  Types.SHIPPING_PROVIDER_TANGIBLE.includes(
                    props.data.shipping.provider
                  )
                  ? ['Shipping', (
                      Types.SHIPPING_METHOD_LABELS_MAP[
                        props.data.shipping.method
                      ]
                    )]
                  : null
                ),
                (
                  (
                    props.data.shipping.referenceId
                    && props.data.shipping.referenceId !== props.data._id
                  )
                  ? ['Shipping Reference ID', (
                      props.data.shipping.referenceId
                    )]
                  : null
                ),
                (
                  props.data.shipping.trackingUrl
                  ? ['Tracking URL', (
                      // eslint-disable-next-line react/jsx-key
                      <a
                        href={props.data.shipping.trackingUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {
                          props.data.shipping.trackingId
                          || props.data.shipping.trackingUrl
                        }
                      </a>
                    )]
                  : props.data.shipping.trackingId
                  ? ['Tracking ID', props.data.shipping.trackingId]
                  : null
                ),
                (
                  (
                    !props.data.shipping.company
                    && !props.data.shipping.companyName
                  )
                  ? null
                  : ['Carrier', (
                      props.data.shipping.company?.name
                      ? (
                          props.viewer.role === 'ADMIN'
                          ? (
                              <Link
                                to={`/shipping/companies/${
                                  props.data.shipping.company._id
                                }`}
                              >
                                {props.data.shipping.company.name}
                              </Link>
                            )
                          : props.data.shipping.company.name
                        )
                      : `${props.data.shipping.companyName} (Packman RUSH)`
                    )]
                ),
              ]
            : []
          ),
          ...(
            props.data?.payment && props.data?.payment?.method
            ? [
                ['Payment', (
                  <>
                    {
                      Types.PAYMENT_METHOD_LABELS[
                      Types.PAYMENT_METHOD.indexOf(props.data?.payment?.method)
                      ]
                    }
                    {
                      props.data.payment?.submethod === 'APPLE_PAY'
                      ? (
                          <ApplePayMark
                            alt="Apple Pay Mark"
                            src={applePayMarkSrc}
                          />
                        )
                      : null
                    }
                    {
                      (
                        props.viewer?.role === 'ADMIN'
                        && props.data.payment?.method === 'CARD'
                      )
                      ? (
                        <>
                          <span style={{ marginLeft: '10px' }}>
                            |
                          </span>
                          <span style={{ marginLeft: '8px' }}>
                            {`${
                              Types.PAYMENT_CARD_PROVIDER_MAP[
                                props.data.payment?.provider
                              ]?.label
                              ? Types.PAYMENT_CARD_PROVIDER_MAP[
                                props.data.payment?.provider
                              ]?.label
                              : props.data.payment?.provider
                            }`}
                          </span>
                        </>
                      )
                      : null
                    }
                  </>
                )],
                (
                  props.data.payment?.refunded
                  ? ['Refunded', 'Yes']
                  : null
                ),
              ]
            : []
          ),
          (
            props.data.discountCodeValue
            ? [
                'Discount',
                props.data.discountCode
                ? (
                    <Link
                      to={
                          props.viewer && props.viewer.role === 'ADMIN'
                        ? `/discountcodes/${props.data.discountCode._id}`
                        : `/store/discountcodes/${props.data.discountCode._id}`
                      }
                    >
                      <Tag style={{ cursor: 'pointer' }}>
                        {props.data.discountCode.code}
                      </Tag>
                    </Link>
                  )
                : (
                    <Tag style={{ textDecoration: 'line-through' }}>
                      {props.data.discountCodeValue}
                    </Tag>
                  ),
              ]
            : null
          ),
          (
            props.data.comment
            ? ['Comment', props.data.comment]
            : null
          ),
          (
            props?.data?.payment !== null
            ? (
                (
                  (
                    props.data?.payment?.provider === PaymentProvider.PAYMOB
                    // eslint-disable-next-line max-len
                    || props.data?.payment.provider === PaymentProvider.PAYMOB_PIXEL
                  )
                  && props.data?.payment?.paymobId
                )
                ? ['Payment ID', (
                    `${props.data.payment?.paymobId}`
                  )]
                : (
                  props.data?.payment?.provider === PaymentProvider.PAYTABS
                  && props.data?.payment?.paytabsReference
                )
                ? ['Payment ID', (
                    `${props.data.payment?.paytabsReference}`
                  )]
                : (
                    props.data.payment?.provider === PaymentProvider.CHECKOUT
                    && props.data.payment.checkoutId
                  )
                ? ['Payment ID', (
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={getCheckoutComTransactionUrlBasedOnStoreId(
                        props.data.store._id,
                        {
                          v1: {
                            query: {
                              search: props.data.payment.checkoutId,
                              sortColumn: 'timestamp',
                              sortOrder: 'desc',
                              pageSize: 25,
                              startIndex: 0,
                            },
                          },
                          v2: {
                            checkoutId: props.data.payment.checkoutId,
                          },
                        },
                        props.data?.payment?.checkoutVersion,
                      )}
                    >
                      {props.data?.payment?.checkoutId}
                    </a>
                  )]
                : (
                    props.data?.payment?.provider === PaymentProvider.TAMARA
                    && props.data.payment.orderId
                  )
                ? ['Payment ID', (
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={`${
                        process.env.REACT_APP_TAMARA_URL
                      }/#/order/detail/${
                        props.data?.payment?.orderId
                      }`}
                    >
                      {/* {props.data.payment ? props.data?.payment?.orderId : ''}\ */}
                      test
                    </a>
                  )]
                : null
              )
            : null
          ),
          (
            (props.data.status !== 'DRAFT' && props.data.message)
            ? ['Error', props.data.message]
            : null
          ),
          (
            (props.data.status !== 'DRAFT' && props.data.message
              && props.data.payment.error && props.viewer
              && props.viewer.role === 'ADMIN')
              ? ['Payment Error', props.data.payment.error]
            : null
          ),
          ...(
            props.viewer && props.viewer.role === 'ADMIN'
            ? [
                  props.data.tinSeller
                ? ['Seller Tax Invoice Number', (
                    props.data.tinSeller || '-'
                  )]
                : null,
                  props.data.tinCustomer
                ? ['Customer Tax Invoice Number', (
                    props.data.tinCustomer || '-'
                  )]
                : null,
              ]
            : []
          ),
        ]],
        (
          props.data.shippingDetails
          ? (
              ['Customer', [
                (
                  props.data.customerStore
                  ? ['Store', (
                        props.data.customerStore._id
                      ? (
                          <Link
                            to={`/stores/${props.data.customerStore._id}`}
                          >
                            {props.data.customerStore.name}
                          </Link>
                        )
                      : props.data.customerStoreName
                    )]
                  : null
                ),
                ['Name', (
                  props.data?.saleSummaries?.customer
                  || props.data?.saleSummaries?.customerStore
                  ? (
                      <Link
                        to={
                          (
                            props?.viewer?.role === 'ADMIN'
                            && props.data?.saleSummaries?.customer
                          )
                          ? `/customers/${props.data.saleSummaries.customer}`
                          : `/store/customers/${
                              props.data.saleSummaries.storeCustomer
                            }`
                        }
                      >
                        {props.data.shippingDetails.name}
                      </Link>
                    )
                  : props.data.shippingDetails.name
                )],
                ...(
                  props.data.shipping.provider === ShippingProvider.POS
                  ? []
                  : [
                      ['Email', (
                        // eslint-disable-next-line react/jsx-key
                        <EmailLink
                          email={props.data.shippingDetails.email}
                          orderId={props.data._id}
                        />
                      )],
                      ['Phone', (
                        // eslint-disable-next-line react/jsx-key
                        <PhoneNumberLink
                          phoneNumberString={
                            props.data.shippingDetails.phoneNumberString
                          }
                        />
                      )],
                      ['Address', `${
                        props.data.shippingDetails.address.streetName
                        ? `${
                          props.data.shippingDetails.address.streetName
                        }${
                          props.data.shippingDetails.address.streetNumber
                          ? ` ${
                            props.data.shippingDetails.address.streetNumber
                          }`
                          : ''
                        }${
                          props.data.shippingDetails.address.area
                          ? `, ${props.data.shippingDetails.address.area}`
                          : ''
                        }, ${
                          props.data.shippingDetails.address.city
                        }, ${
                          Types.COUNTRIES_MAP[
                            props.data.shippingDetails.address.country
                          ]?.name
                        }`
                        : props.data.shippingDetails.address.lines
                      }`],
                      ['Address line 1', `${
                        props.data.shippingDetails.address.line1
                        ? `${
                          props.data.shippingDetails.address.line1
                        }`
                        : ''
                      }`],
                      ['Address line 2', `${
                        props.data.shippingDetails.address.line2
                        ? `${
                          props.data.shippingDetails.address.line2
                        }`
                        : ''
                      }`],
                      (
                        props.data.shippingDetails.address.country === 'sa'
                        && props.data.shippingDetails.ksaNationalAddress
                        ? ['KSA National Address',
                            props.data.shippingDetails.ksaNationalAddress]
                        : null
                      ),
                    ]
                ),
              ]]
            )
          : null
        ),
        (
          props.data.reviewed
            ? ['Review', [
              ['Product Reviews', (
                <Link
                  to={`${getRoleBasedPath(
                    props,
                    `/reviews?order=${props.data._id}`
                  )}`}
                >
                  See All
                </Link>
              )],
              ['Order Rating', (
                <span>
                  <Rate disabled value={props.data.rating} allowHalf />
                  <span>
                    {' '}
                    (
                    {Types.decimalize(props.data.rating, '.', 1)}
                    )
                  </span>
                </span>
              )],
              (
                props.data.testimonial
                  ? ['Testimonial', props.data.testimonial]
                  : null
              ),
            ]]
            : null
        ),
        (
          (
            props.data.shipping
            && Types.SHIPPING_PROVIDER_TANGIBLE.includes(
              props.data.shipping.provider
            )
            && props.data.pickupDetails
          )
          ? (
              ['Pickup', [
                ['From', props.data.pickupDetails.name],
                ['Email', (
                  // eslint-disable-next-line react/jsx-key
                  <EmailLink
                    email={props.data.pickupDetails.email}
                    orderId={props.data._id}
                  />
                )],
                ['Phone', (
                  // eslint-disable-next-line react/jsx-key
                  <PhoneNumberLink
                    phoneNumberString={
                      props.data.pickupDetails.phoneNumberString
                    }
                  />
                )],
                ['Address', props.data.pickupDetails.address.lines],
              ]]
            )
          : null
        ),
        ['Cost', [
          ['Items', renderCurrency({ prefix: `${
            Types.decimalize(cost.items + cost.vat)
          } ` })],
          (
            cost.itemsDiscount > 0
            ? ['Items Discount', renderCurrency({ prefix: `${
                Types.decimalize(cost.itemsDiscount)
              } ` })]
            : null
          ),
          // (
          //   cost.vat
          //   ? ['Items VAT', renderCurrency({ prefix: `${
          //       Types.decimalize(cost.vat)
          //     } ` })]
          //   : null
          // ),
          (
            (
              props.data.shipping
              && !isSellerOnResellerOrder
              && Types.SHIPPING_PROVIDER_TANGIBLE.includes(
                  props.data.shipping.provider
                )
            )
            ? [
                'Shipping',
                <>
                  <ValueSpaceBetweenWrapper>
                    <ValueSpaceBetweenRight>
                      {
                        renderCurrency({ prefix: `${
                          Types.decimalize(cost.shipping)
                        }${
                          (
                            !isSellerOnResellerOrder
                            && getKey(props.data, 'shipping.free') === true
                          )
                          // ? ' (free)'
                          ? ''
                          : ''
                        } ` })
                      }
                    </ValueSpaceBetweenRight>
                    {(() => {
                      const tags = [
                        ...(
                          (
                            props.data.shipping
                            && viewer
                            && viewer.role === 'ADMIN'
                            && cost.shippingMultiplier > 1
                            && (
                              Types.SHIPPING_PROVIDER_TANGIBLE.includes(
                                props.data.shipping.provider
                              )
                            )
                          )
                          ? [(
                              <GhostTag key="multiplier">
                                {`Multi x${cost.shippingMultiplier}`}
                              </GhostTag>
                            )]
                          : []
                        ),
                        ...(
                          cost.shippingAttributes > 0
                          ? (
                              Object
                              .keys(cost.shippingAttributesMap)
                              .reduce(
                                (agr, key) => {
                                  const value = (
                                    cost.shippingAttributesMap?.[key]
                                  );
                                  if (value > 0) {
                                    agr.render.push(
                                      <GhostTag key={key}>
                                        {
                                          `${
                                            Types
                                            .PRODUCT_ATTRIBUTE_LABELS_MAP[key]
                                            || key
                                          } ${
                                            Types.decimalize(value)
                                          }`
                                        }
                                      </GhostTag>
                                    );
                                    agr.index += 1;
                                  }
                                  return agr;
                                },
                                {
                                  render: [],
                                  index: 0,
                                },
                              )
                              .render
                            )
                          : []
                        ),
                      ].filter(tag => tag);
                      if (tags.length) {
                        return (
                          <ValueSpaceBetweenLeft>
                            {tags}
                          </ValueSpaceBetweenLeft>
                        );
                      }
                      return null;
                    })()}
                  </ValueSpaceBetweenWrapper>
                </>,
              ]
            : null
          ),
          (
            !isSellerOnResellerOrder && cost.shippingDiscount > 0
            ? ['Discount', renderCurrency({ prefix: `${
                Types.decimalize(cost.shippingDiscount)
              } ` })]
            : null
          ),
          (
            cost.resellerCommission > 0
            ? ['Reseller Commission', renderCurrency({ prefix: `${
                cost.resellerCommission
              } ` })]
            : null
          ),
          (
            !isSellerOnResellerOrder && cost.resellerAddedValue > 0
            ? ['Reseller Added Value', renderCurrency({ prefix: `${
                cost.resellerAddedValue
              } ` })]
            : null
          ),
          (
            cost.payment > 0
            ? [
                'Payment',
                (
                  <>
                    <ValueSpaceBetweenWrapper>
                      <ValueSpaceBetweenRight>
                        {
                          renderCurrency({
                            prefix: `${
                              Types.decimalize(cost.payment)
                            } `,
                          })
                        }
                      </ValueSpaceBetweenRight>
                      {(() => {
                        if (viewer.role === 'ADMIN') {
                          return (
                            <ValueSpaceBetweenLeft>
                              <GhostTag>
                                {`${Types.PAYMENT_METHOD_LABELS_MAP[
                                  props.data.payment.method
                                ]}`}
                              </GhostTag>
                            </ValueSpaceBetweenLeft>
                          );
                        }
                        return null;
                      })()}
                    </ValueSpaceBetweenWrapper>
                  </>
                ),
              ]
            : null
          ),
          (
            cost.paymentDiscount
            ? ['Discount', renderCurrency({ prefix: `${
                Types.decimalize(cost.paymentDiscount)
              } ` })]
            : null
          ),
          (
            props.data.referral
            ? ['Referral Revenue', renderCurrency({ prefix: `${
                Types.decimalize(cost.referralRevenue || 0)
              } ` })]
            : null
          ),
          (
            cost.serviceFee > 0
            ? [
                'Service Fee',
                (
                  <>
                    <ValueSpaceBetweenWrapper>
                      <ValueSpaceBetweenRight>
                        {
                          renderCurrency({ prefix: `${
                            Types.decimalize(
                              (cost.serviceFee + cost.serviceFeeVat)
                              || 0
                            )
                          } ` })
                        }
                      </ValueSpaceBetweenRight>
                      {(() => {
                        if (
                          cost.serviceFeeChargedTo === 'CUSTOMER'
                          && viewer.role === 'ADMIN'
                        ) {
                          return (
                            <ValueSpaceBetweenLeft>
                              <GhostTag>
                                Charged to Customer
                              </GhostTag>
                            </ValueSpaceBetweenLeft>
                          );
                        }
                        return null;
                      })()}
                    </ValueSpaceBetweenWrapper>
                  </>
                ),
              ]
            : null
          ),
          (
            cost.platformFee > 0
            ? [
                'Platform Fee',
                renderCurrency({ prefix: `${
                  Types.decimalize(
                    (cost.platformFee + cost.platformFeeVat)
                    || 0,
                  )
                } ` }),
              ]
            : null
          ),
          (
            cost.paymentGateway > 0
            ? ['Payment Fee', renderCurrency({ prefix: `${
                Types.decimalize(
                  (cost.paymentGateway + cost.paymentGatewayVat)
                  || 0
                )
              } ` })]
            : null
          ),
          ['Charged', renderCurrency({ prefix: `${
            Types.decimalize(cost.charged)
          } ` })],
        ], false, {
          valueProps: {
            style: {
              display: 'inline-block',
              width: '100%',
              textAlign: 'right',
            },
          },
        }],
        ['Airway Bill', (
          <Descriptions.Item>
            <AirwayBillSection
              data={props.data}
              client={props.client}
              reload={props.reload}
              viewer={props.viewer}
            />
          </Descriptions.Item>
        ), false],
        ['Invoice', (
          <Descriptions.Item>
            <InvoiceSection
              data={props.data}
              client={props.client}
              reload={props.reload}
              viewer={props.viewer}
            />
          </Descriptions.Item>
        ), false],
          ['Note', [
              ['Admin Note', props.data?.adminNote || '-'],
            ], false],
        ['Items', (
          // eslint-disable-next-line react/jsx-key
          <Descriptions.Item>
            <List
              itemLayout="horizontal"
              dataSource={items}
              renderItem={item => (
                <List.Item>
                  <List.Item.Meta
                    title={(
                      <>
                        <Link to={`/products/${item.product}`}>
                          {item.name}
                        </Link>
                      </>
                    )}
                    description={(
                      <>
                        <span>
                          {
                            renderCurrency({
                              suffix: ` x ${item.quantity}`,
                              prefix: `${Types.decimalize(
                                  isSellerOnResellerOrder
                                ? item.priceOrigin
                                : (
                                  data.store?.trn?.active
                                  ? (
                                    item.price
                                    * (
                                      1
                                      + Types.getSystemCountry(
                                        data.systemCountry
                                      ).VAT
                                    )
                                  )
                                  : item.price
                                )
                              )} `,
                            })
                          }
                          {
                            item.comment
                            ? ` / Comment: ${item.comment}`
                            : ''
                          }
                          {
                            item.options.length
                            ? ` / ${item.options.map(option => `${
                                option.label
                              }: ${
                                option.value || 'N/A'
                              }`).join(' / ')}`
                            : ''
                          }
                          {
                            item.attributes?.length
                            ? (
                                <span style={{ marginLeft: '10px' }}>
                                  {
                                    item.attributes
                                    .map(key => (
                                      <Tag key={key}>
                                        {
                                          Types
                                          .PRODUCT_ATTRIBUTE_LABELS_MAP[key]
                                        }
                                      </Tag>
                                    ))
                                  }
                                </span>
                              )
                            : null
                          }
                        </span>
                        {
                          isAdmin && isStorageWarehouse
                          ? (
                              <>
                                <br />
                                <span>
                                  {`Warehouse: Row ${
                                    item.warehouseRow || '-'
                                  } / Rack ${
                                    item.warehouseRack || '-'
                                  } / Shelf ${
                                    item.warehouseShelf || '-'
                                  }`}
                                </span>
                              </>
                            )
                          : null
                        }
                        {
                          item?.extras?.length > 0 && (
                          <div style={{ margin: '10px 0' }}>
                            <span>
                             Bundle Info
                            </span>
                          <div>
                            {
                              item.extras.map((extra, index) => {
                                const extraArray = Object.values(extra);
                               return (
                               <div style={{ margin: '10px 0' }}>
                                  <span>
                                    Item No.
                                    {index + 1}
                                  </span>
                                  {
                                    // eslint-disable-next-line max-len
                                    extraArray.map(({ optionTitle, selectedLabel }) => (
                                       // eslint-disable-next-line max-len
                                      <div style={{ display: 'flex', gap: '5px' }}>
                                         {/* eslint-disable-next-line max-len */}
                                        <span>
                                          <strong>
                                            {optionTitle}
                                          </strong>
                                           :
                                        </span>
                                        <span>
                                          {selectedLabel}
                                        </span>
                                      </div>
                                    ))
                                  }
                               </div>
                                )
                    })
                            }
                          </div>
                          </div>
                           )
                        }
                      </>
                    )}
                    avatar={(
                        item.image?.src
                        ? (
                          <Tooltip
                            placement="topLeft"
                            title={(
                              <OrderItemPopoverImage
                                alt="Product"
                                src={item.image.src}
                              />
                            )}
                          >
                            <Avatar
                              src={item.image.src}
                              size="large"
                              shape="square"
                              style={{ backgroundColor: '#f8f8f8' }}
                            />
                          </Tooltip>
                        )
                      : (
                        <Avatar
                          src={item.image?.src || null}
                          size="large"
                          shape="square"
                          style={{ backgroundColor: '#f8f8f8' }}
                        />
                      )
                    )}
                  />
                </List.Item>
              )}
            />
          </Descriptions.Item>
        ), false],
      ]
      .reduce(
        // eslint-disable-next-line no-unused-vars
        (sections, section, index, initialSectionsArray) => {
          // console.log({ sections, section })
          if (section) {
            sections.push(
              <OrderDescriptionSectionSeparator
                key={`${section[0]}-separator`}
              />
            );
            const {
              valueProps = {},
              ...descriptionProps
            } = section[3] || {};
            sections.push(
              <OrderDescription
                key={section[0]}
                title={section[0]}
                column={1}
                size="small"
                // colon={false}
                bordered={isArray(section[1])}
                {...descriptionProps}
              >
                {
                  isArray(section[1])
                  ? section[1].reduce(
                      (list, item) => {
                        if (item) {
                          list.push(
                            <Descriptions.Item
                              key={item[0]}
                              label={(
                                <DescriptionLabel>
                                  {item[0]}
                                </DescriptionLabel>
                              )}
                            >
                              <DescriptionValue {...valueProps}>
                                {item[1]}
                              </DescriptionValue>
                            </Descriptions.Item>
                          );
                        }
                        return list;
                      },
                      [],
                    )
                  : section[1]
                }
              </OrderDescription>
            );
          }
          return sections;
        },
        [],
      );
    },
  }],
  Admin.compileFromLibrary(['FieldTextArea', {
    name: 'adminNote',
    label: 'Admin Note',
    placeholder: 'Add notes about this order (visible to admins only)...',
    autoSize: {
      minRows: 3,
      maxRows: 8,
    },
    skip: [
      tests.viewerIsNotAdmin,
    ],
  }]),
  ...createChangeLogSection({
    titleStyle: {
      marginBottom: '20px',
      fontSize: '22px',
      lineHeight: '1.5',
      fontWeight: 'bold !important',
    },
    textStyle: {
      color: '#aa407a',
      fontWeight: 'bold !important',
    },
    changeLogConfig: {
      getWhereConditions: props => ({
        store: props.data?.store?._id || props.data?.store,
        'target.type': 'Order',
        'target.subject': props.data._id,
      }),
      skipColumns: {
        store: true,
        realm: true,
        target: true,
      },
    },
  }),
];

export const ADMIN = FIELDS;
export const SELLER_MERCHANT = FIELDS;
export const SELLER_REFERRAL = FIELDS;
export const SELLER_RESELLER = FIELDS;
